import Icons from "@/src/components/Icons";
import Modal from "@/src/components/Modal";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
interface modalProps {
  open: any;
  close: any;
  data: any;
  items: any;
}
function ModalOrder({ open, close, data, items }: modalProps) {
  return (
    <Modal open={open} onClose={close}>
      <div className="min-w-[340px] pb-3">
        <div className="text-center font-bold">{data && data.name}</div>
        <div className="flex flex-col items  gap-4 mt-2">
          {items &&
            items.length > 0 &&
            items
              .sort((a: any, b: any) =>
                a.foodType === "غذای اصلی" && b.foodType !== "غذای اصلی"
                  ? -1
                  : 1
              )
              .map((item: any) => {
                return (
                  <div className="item">
                    <div
                      className={`border border-gray-50-mmpz shadow-mmpz ${
                        item.foodType == "غذای اصلی" ? "h-[60px]" : "h-[42px]"
                      } rounded-xl p-2 flex justify-between items-center`}
                    >
                      <p className="mb-0 flex w-3/4">
                        {item.foodType == "غذای اصلی" ? (
                          <Icons name="food" size={24} className="me-2" />
                        ) : item.foodType == "کنار غذا" ? (
                          <Icons name="sideFood" size={18} className="me-2" />
                        ) : (
                          <Icons name="other" size={18} className="me-2" />
                        )}{" "}
                        {item.foodName}
                      </p>
                      <span className="font-bold text-gray-300-mmpz text-sm">
                        {" "}
                        {digitsEnToFa(item.count)} عدد{" "}
                      </span>
                    </div>
                  </div>
                );
              })}
        </div>
        {data && data.menuDescription && (
          <div className="my-2 mb-4">
            <span className="text-sm">توضیحات</span>
            <div className="bg-white w-full shadow-mmpz rounded-xl p-2 my-2 border border-error">
              <span className="text-sm text-gray-300-mmpz">
                {data.menuDescription}
              </span>
            </div>
          </div>
        )}
        <div className="rounded shadow-mmpz flex gap-4 items-center w-fit p-2 mt-3">
          <span className="flex items-center gap-2 text-sm">
            <Icons name="time" size={18} />{" "}
            {data && digitsEnToFa(moment(data.deliveryDate).format("HH:mm"))}
          </span>
          <span className="flex items-center gap-2 font-bold text-gray-200-mmpz text-sm">
            <Icons name="date" size={18} fill="none" />
            {data &&
              digitsEnToFa(moment(data.deliveryDate).format("jYYYY-jMM-jDD"))}
          </span>
        </div>
        <p className="flex gap-2 mt-3">
          <Icons name="location" fill="none" size={20} />
          <span className="text-sm text-[#4B4B4B]">
            {data && data.address && data.address[0]}
          </span>{" "}
        </p>
      </div>
    </Modal>
  );
}

export default ModalOrder;
